var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0V6.92308C9 7.53512 9.22224 8.12209 9.61782 8.55486C10.0134 8.98764 10.5499 9.23077 11.1094 9.23077H18V22.1538C18 22.6435 17.8222 23.1131 17.5057 23.4593C17.1893 23.8055 16.7601 24 16.3125 24H1.6875C1.23995 24 0.810725 23.8055 0.494257 23.4593C0.177789 23.1131 0 22.6435 0 22.1538V1.84615C0 1.35652 0.177789 0.886947 0.494257 0.540726C0.810725 0.194505 1.23995 0 1.6875 0H9ZM10.4062 0.285539V6.92308C10.4062 7.34769 10.7212 7.69231 11.1094 7.69231H17.6974L10.4062 0.285539Z",
    fill: "#008080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveProjects);
export default __webpack_public_path__ + "static/media/active_projects.38a5e42af2887baede77b72c13009116.svg";
export { ForwardRef as ReactComponent };